<template><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
	<path d="M15.7,14.2l-4-4l-1.5,1.5l4,4c0.4,0.4,1.1,0.4,1.5,0C16.1,15.3,16.1,14.6,15.7,14.2z" />
	<path d="M6.5,1.4c2.8,0,5.1,2.3,5.1,5.1s-2.3,5.1-5.1,5.1S1.4,9.3,1.4,6.5S3.7,1.4,6.5,1.4 M6.5,0C2.9,0,0,2.9,0,6.5S2.9,13,6.5,13S13,10.1,13,6.5S10.1,0,6.5,0L6.5,0z" />
	<rect x="3" y="5.8" width="7" height="1.5" />
</svg>
</template>